module.exports = __webpack_public_path__ + "img/icon-home-phone-active.4ea093d9.svg";